// "use client";

// import React from "react";
// import PlayVideoIcon from "@/assets/icons/playvideo.svg";
// import Image from "next/image";

// const VideoBaner = ({ videoSrc, banner_bredcrumb_name, banner_name }) => {
//   return (
//     <div className="relative  w-full h-64 md:h-80 lg:h-[420px] overflow-hidden">
//       <video
//         className="absolute inset-0 w-full h-full object-cover"
//         src={videoSrc}
//         autoPlay
//         loop
//         muted
//         playsInline
//       />
//       <div className="absolute inset-0 bg-[#011b30]/70" />
//       <div className="absolute inset-0 z-10 flex items-center">
//         <div className="w-full  mx-auto px-4 md:px-14">
//           <div className="max-w-md">
//             <h1
//               className="text-[30px] md:text-[48px] text-white font-extrabold"

//             >
//               {banner_name}
//             </h1>
//             {banner_bredcrumb_name && (
//               <p className="font-medium text-white leading-tight">
//                 {banner_bredcrumb_name}
//               </p>
//             )}
//           </div>
//         </div>
//       </div>
//       <div className="absolute inset-x-0 bottom-5 z-10">
//         <div className="w-full  mx-auto px-4 md:px-14 flex justify-end">
//           <button
//             className="inline-flex items-center gap-2 text-[10px] md:text-xs tracking-[0.25em] uppercase text-white/80 hover:text-white"
//             style={{ fontFamily: "saans-regular" }}
//           >
//             View video
//             <Image src={PlayVideoIcon} alt="Play Video" className="h-3 w-3 md:h-4 md:w-4" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VideoBaner;
"use client";

import React from "react";
import Image from "next/image";
import PlayVideoIcon from "@/assets/icons/playvideo.svg";

/* =======================
   HELPERS
   ======================= */

// Check if YouTube URL
const isYouTubeUrl = (url = "") =>
  url.includes("youtube.com") || url.includes("youtu.be");

// Extract YouTube ID safely
const getYouTubeId = (url = "") => {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&?/]+)/,
  );
  return match ? match[1] : null;
};

/* =======================
   COMPONENT
   ======================= */

const VideoBanner = ({
  videoSrc,
  banner_bredcrumb_name,
  banner_name,
}) => {
  const isYouTube = isYouTubeUrl(videoSrc);
  const youtubeId = isYouTube ? getYouTubeId(videoSrc) : null;

  return (
    <div className="relative w-full h-64 md:h-80 lg:h-[440px] overflow-hidden">
      {/* ================= BACKGROUND VIDEO ================= */}

      {/* ▶ AWS / CDN VIDEO */}
      {!isYouTube && videoSrc && (
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={videoSrc}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
      )}

      {/* ▶ YOUTUBE VIDEO */}
      {isYouTube && youtubeId && (
        <div className="absolute inset-0 overflow-hidden">
          {/* 16:9 cover math */}
          <div
            className="
              absolute top-1/2 left-1/2
              w-[177.78vh] h-[100vh]
              min-w-[100vw] min-h-[56.25vw]
              -translate-x-1/2 -translate-y-1/2
            "
          >
            <iframe
              src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&loop=1&playlist=${youtubeId}&controls=0&modestbranding=1&rel=0`}
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        </div>
      )}

      {/* ================= OVERLAY ================= */}
      <div className="absolute inset-0 bg-[#011b30] opacity-70" />

      {/* ================= CONTENT ================= */}
      <div className="absolute inset-0 z-10 flex items-center">
        <div className="w-full mx-auto px-4 md:px-14">
          <div className="">
            <h1 className="text-[30px] md:text-[48px] text-white font-extrabold">
              {banner_name}
            </h1>

            {banner_bredcrumb_name && (
              <p className="mt-1 font-medium text-white leading-tight">
                {banner_bredcrumb_name}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* ================= CTA ================= */}
      <div className="absolute inset-x-0 bottom-5 z-10">
        <div className="w-full mx-auto px-4 md:px-14 flex justify-end">
          <a
            href={
              isYouTube
                ? `https://www.youtube.com/watch?v=${youtubeId}`
                : videoSrc
            }
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[10px] md:text-xs tracking-[0.25em] uppercase text-white/80 hover:text-white"
            style={{ fontFamily: "saans-regular" }}
          >
            View video
            <Image
              src={PlayVideoIcon}
              alt="Play Video"
              className="h-3 w-3 md:h-4 md:w-4"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default VideoBanner;
